import React from 'react';
import { Messages } from '../../codegen/Localize';
import { interpolateString, IReplacements } from '../../common/utilities/StringInterpolation';
import { TextChannel } from './TextChannel';

/**
 * used to center the background image in the favorites span. The original class has the image
 * offset by 2px x 2px
 */
const centerBackgroundPosition: React.CSSProperties = {
  backgroundPosition: '50%',
  pointerEvents: 'none'
};

/**
 * Replacements for the {@link interpolateString()} function
 */
export const replacements = {
  star_icon: (index: number) => <span key={index} className="tb-favorite-button" style={centerBackgroundPosition} data-tb-test-id="empty-favorite-star-icon" />
};

export class NoFavoritesAndRecentsChannel extends React.PureComponent {
  render() {
    return (
      <TextChannel title={Messages.home_emptyTitleFavoritesAndRecents()}>
            {interpolateString(Messages.home_emptyFavoritesAndRecents(), replacements)}
      </TextChannel>
    );
  }
}
